/**
 * @file reducers/Newsletter/reducer.js
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = () => {
    return { newsletters: false };
};

const newslettersSlice = createSlice({
    name: "newsletters",
    initialState: initialState(),
    reducers: {
        load_data: (state, action) => {
            return { ...state, newsletters: action.payload.newsletters };
        },
        subscribe_email: (state, action) => {
            const subscribeState =
                state.subscribe === undefined ? [] : state.subscribe;
            const cleanList = subscribeState.filter((result) => {
                if (
                    action.payload.subscribe?.message?.newsletter_id ===
                    result.error?.newsletter_id
                ) {
                    return;
                }
                return result;
            });
            return {
                ...state,
                subscribe: [...cleanList, action.payload.subscribe],
            };
        },
        middleware_error: (state, action) => {
            return {
                ...state,
                middleware_error: action.payload.middleware_error,
            };
        },
    },
});

export const {
    load_data: load_newsletters_data,
    subscribe_email: newsletters_subscribe_email,
    middleware_error: newsletters_middleware_error,
} = newslettersSlice.actions;

export default newslettersSlice.reducer;
